import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/InventoryAdjustmentReport/InventoryAdjustmentReportAction'


//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class WarehouseReportInventoryAdjustmentActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/InventoryAdjustmentReport/InventoryAdjustmentReport")
	}

	render() {
		return (
			<Activity 
				name="InventoryAdjustmentReport"
				RenderedComponent={this.RenderedComponent}
				context="InventoryAdjustmentReport"
				action="InventoryAdjustmentReport"
				formActions={FormAction}
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(WarehouseReportInventoryAdjustmentActivity)
